define(['exports', 'react', '../../assets/back-button-circular-black.svg', '../../assets/back-on-hover.svg'], function (exports, _react, _backButtonCircularBlack, _backOnHover) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _backButtonCircularBlack2 = _interopRequireDefault(_backButtonCircularBlack);

	var _backOnHover2 = _interopRequireDefault(_backOnHover);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var BackButton = function (_Component) {
		_inherits(BackButton, _Component);

		function BackButton(props) {
			_classCallCheck(this, BackButton);

			var _this = _possibleConstructorReturn(this, (BackButton.__proto__ || Object.getPrototypeOf(BackButton)).call(this, props));

			_this.state = {
				mouseOver: false
			};
			return _this;
		}

		_createClass(BackButton, [{
			key: 'render',
			value: function render() {
				var _this2 = this;

				var onClick = this.props.onClick;

				return _react2.default.createElement(
					'div',
					{
						onMouseEnter: function onMouseEnter() {
							return _this2.setState({ mouseOver: true });
						},
						onMouseLeave: function onMouseLeave() {
							return _this2.setState({ mouseOver: false });
						} },
					this.state.mouseOver ? _react2.default.createElement(_backOnHover2.default, {
						className: 'clickable relative',
						onTouchTap: onClick }) : _react2.default.createElement(_backButtonCircularBlack2.default, {
						className: 'clickable relative',
						onTouchTap: onClick })
				);
			}
		}]);

		return BackButton;
	}(_react.Component);

	exports.default = BackButton;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/common/BackButton.js
// module id = 1147
// module chunks = 0